<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { computed } from 'vue'
import type { SettingPageLineActivationInflowSourceFormAssignedStaffFragment } from './SettingPageLineActivationInflowSourceFormAssignedStaff.generated'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import IconClose from '@/components/icons/IconClose.vue'

const assignedStaffGuids = defineModel<string[]>({ required: true })

const props = defineProps<{
  allStaffs: SettingPageLineActivationInflowSourceFormAssignedStaffFragment[]
}>()

const staffOptions = computed(() =>
  props.allStaffs
    .filter(staff => !assignedStaffGuids.value.includes(staff.guid))
    .map(staff => ({
      text: staff.displayName,
      value: staff.guid,
    }))
)

const handleChange = (staffGuid: string) => {
  // eslint-disable-next-line fp/no-mutating-methods
  assignedStaffGuids.value.push(staffGuid)
}

const allStaffMap = computed<
  Map<string, SettingPageLineActivationInflowSourceFormAssignedStaffFragment>
>(() =>
  props.allStaffs.reduce((acc, staff) => acc.set(staff.guid, staff), new Map())
)

const handleClickDeleteButton = (staffGuid: string) => {
  assignedStaffGuids.value = assignedStaffGuids.value.filter(
    guid => guid !== staffGuid
  )
}
</script>

<template>
  <div :class="$style.selectOptions">
    <div :class="$style.selectOptionRow">
      <!-- やや違和感のある見た目なのでいい感じになおしてほしい -->
      <DolphinSelector
        :class="$style.select"
        :options="staffOptions"
        @update:model-value="v => handleChange(v as string)"
      />
    </div>
    <div :class="$style.rows">
      <div
        v-for="staffGuid in assignedStaffGuids"
        :key="staffGuid"
        :class="$style.row"
      >
        <p :class="$style.rowContent">
          {{ allStaffMap.get(staffGuid)?.displayName }}
        </p>
        <FlatButton
          variant="base"
          :class="$style.deleteButton"
          @click="handleClickDeleteButton(staffGuid)"
          ><IconClose
        /></FlatButton>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.selectOptions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 540px;
}

.selectOptionRow {
  display: flex;
  gap: 8px;
}

.select {
  flex: 1;
}

.selectOptionRowInput {
  flex: 1;
  height: 39px;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rowContent {
  flex: 1;
}

.deleteButton {
  padding: 8px 16px;
}
</style>
